export type GuestReview = {
    id: number;
    propertyId: number;
    propertyName: string;
    accomodationUnitTypeId: number;
    accomodationUnitTypeName: string;
    guestName: string;
    countryId: number;
    reviewSubmitDate: string;
    reviewApprovalDate: string;
    reviewTextGeneral: string;
    reviewTextPros: string;
    reviewTextCons: string;
    generalScore: number;
    cleanlinessScore: number;
    locationScore: number;
    valueForMoneyScore: number;
    facilitiesScore: number;
    staffScore: number;
    comfortScore: number;
    wifiScore: number;
    sortOrder: number;
    statusId: number;
}

export type GuestReviewStatus = {
    id: number;
    name: string;
    textResourceKey: string;
}

export class GuestReviewModel {
    id: number | null = null;
    guestName: string | null = null;
    reviewSubmitDate = new Date().toISOString().substr(0, 10);
    reviewApprovalDate: string | null = null;
    propertyId: number | null = null;
    accomodationUnitTypeId: number | null = null;
    countryId: number | null = null;
    reviewTextGeneral: string | null = null;
    reviewTextPros: string | null = null;
    reviewTextCons: string | null = null;
    generalScore: number | null = null;
    cleanlinessScore: number | null = null;
    locationScore: number | null = null;
    valueForMoneyScore: number | null = null;
    facilitiesScore: number | null = null;
    staffScore: number | null = null;
    comfortScore: number | null = null;
    wifiScore: number | null = null;
    statusId = 1;
}